export default __webpack_public_path__ + "static/media/RivetGun.4879fcbd.jpeg";